/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ api: NonNullable<unknown> }} Audit_Details_Api_Template_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The approval of the external API \"{api}\" was changed." |
*
* @param {Audit_Details_Api_Template_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_api_template_updated_desc = /** @type {((inputs: Audit_Details_Api_Template_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Api_Template_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Freigabe der externen API "${i?.api}" wurde geändert.`)
	return /** @type {LocalizedString} */ (`The approval of the external API "${i?.api}" was changed.`)
});